export const RINGS = {
  SLOW_RING: 0,
  FAST_RING: 1,
  SUPER_FAST_RING: 2,
  PRODUCTION_RING: 3,
  TEST1_RING: 4,
  TEST2_RING: 5
};


export const ringToDownloadUrlNameMap = {
  [RINGS.SLOW_RING]: {
    "win" : "kit-bstwin",
    "nix" : "kit-bstnix",
    "mac" : "kit-mac-downloader",
  },
  [RINGS.PRODUCTION_RING]: {
    "win" : "kit-bstwin-production",
    "nix" : "kit-bstnix-production",
    "mac" : "kit-mac-downloader-production",
  },
  [RINGS.TEST1_RING]: {
    "win" : "kit-bstwin-test1",
    "nix" : "kit-bstnix-test1",
    "mac" : "kit-mac-downloader-test1",
  },
  [RINGS.TEST2_RING]: {
    "win" : "kit-bstwin-test2",
    "nix" : "kit-bstnix-test2",
    "mac" : "kit-mac-downloader-test2",
  }
}
